<template>
  <div class="holdReceipt">
    <layout-fullpage>
      <page-headline tag="h1" title="歸戶收據查詢" />
      <loading :show="apiLoading" />
      <b-form>
        <div class="form-row dateBox">
          <!-- 收據號碼 -->
          <input-text
            :val="searchForm.rpPublicNo"
            :labelName="'收據號碼'"
            :colClassName="'col-12 col-md-4 mr-2 rpPublicNo'"
            @inputVal="inputVal"
          ></input-text>

          <!-- 收據日期 -->
          <date
            :labelName="'收據日期'"
            :descriptionText="'(資料區間最長3個月)'"
            :receiptStartDate="searchForm.receiptStart"
            :receiptEndDate="searchForm.receiptEnd"
            @inputStartDateVids="startDateVidsOpen"
            @inputEndDateVids="endDateVidsOpen"
          ></date>
          <div class="col-auto searchBtn-circle">
            <!-- getCookieRun(); -->
            <b-button variant="action" class="rounded-circle" @click="search()">
              <i class="fa fa-search"></i>
            </b-button>
          </div>
        </div>

        <b-collapse id="receipt-search-collapse" v-model="searchCollapse">
          <div class="row mt-2">
            <div class="col-12 col-md-4 dateBox">
              <input-select
                :nameItem="'OrganName'"
                :optionData="organList"
                :labelName="'開立機關'"
                :val="''"
                :pk="null"
                :type="'og'"
                :isValidation="false"
                @inputPkId="getInputPkId"
              ></input-select>
            </div>

            <div class="col-12 col-md-4 dateBox" v-if="ispayItemListNew">
              <input-select
                :nameItem="'piName'"
                :optionData="payItemListNew"
                :labelName="'繳款項目'"
                :val="''"
                :pk="null"
                :type="'pi'"
                :isValidation="false"
                @inputPkId="getInputPiId"
              ></input-select>
            </div>
          </div>
        </b-collapse>

        <divider v-b-toggle.receipt-search-collapse title="更多查詢條件" position="center">
          <span class="d-inline-block text-secondary">更多查詢條件</span>
          <span class="d-inline-block ml-2">
            <i
              class="fas"
              :class="[searchCollapse ? 'fa-angle-double-up' : 'fa-angle-double-down']"
            />
          </span>
        </divider>
      </b-form>

      <!-- 手機版 -->
      <div class="d-lg-none">
        <b-card
          no-body
          class="mb-3"
          v-for="(item, index) in tabledatas"
          :key="`RESULT_LIST_MOBILE__${index}`"
        >
          <b-table-simple borderless striped class="mb-0">
            <colgroup>
              <col width="160" />
              <col />
            </colgroup>
            <b-tbody>
              <b-tr>
                <b-th>收據號碼</b-th>
                <b-td>{{ item.rpPublicNo }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>收據日期</b-th>
                <b-td>{{ item.rpDate | TWDateFormat('tYY/MM/DD') }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>繳款機關 / 繳款人</b-th>
                <b-td>{{ item.rpPayManName }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>繳款項目</b-th>
                <b-td>{{ item.piName }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>金額</b-th>
                <b-td>{{ item.rpArAmt | currencyFormat }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>開立機關</b-th>
                <b-td>{{ item.ogName }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>已作廢</b-th>
                <b-td>{{ item.rpStatus === '9' ? '已作廢' : '' }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-card-footer>
            <b-row>
              <b-col>
                <b-button variant="action" block class="m-1" @click="showDetails(item, index)"
                  >明細</b-button
                >
              </b-col>
              <b-col v-if="item.rpStatus !== '9'">
                <b-button variant="action" block class="m-1" @click="previewReceipt(item, index)"
                  >預覽</b-button
                >
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </div>

      <!-- 電腦版 -->
      <div class="d-none d-lg-block">
        <b-table-simple id="itemList" caption-top responsive striped table-class="table-rounded">
          <caption class="sr-only">
            收據查詢結果
          </caption>

          <b-thead head-variant="primary">
            <b-tr>
              <b-th v-for="(subItem, index) in tableTh" :key="index" :class="subItem.class">{{
                subItem.title
              }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, index) in tabledatas" :key="`RESULT_LIST__${index}`">
              <!-- <b-th class="text-center">{{ index + 1 }}</b-th> -->
              <b-td>{{ item.rpPublicNo }}</b-td>
              <b-td class="text-center">{{ item.rpDate | TWDateFormat('tYY/MM/DD') }}</b-td>
              <b-td>{{ item.rpPayManName }}</b-td>
              <b-td>{{ item.piName }}</b-td>
              <b-td style="text-align: right">{{ item.rpRealAmt | currencyFormat }}</b-td>
              <b-td>{{ item.ogName }}</b-td>
              <b-td>{{ item.rpStatus === '9' ? '已作廢' : '' }}</b-td>
              <b-td class="text-nowrap" style="text-align: center">
                <b-button variant="action" size="sm" class="m-1" @click="showDetails(item)"
                  >明細</b-button
                >
                <b-button
                  v-if="item.rpStatus !== '9'"
                  variant="action"
                  size="sm"
                  class="m-1"
                  @click="previewReceipt(item)"
                  >預覽</b-button
                >
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <div>
        <span class="totalListLength"> 總筆數:{{ tableData.length }} </span>
        <!-- 分頁元件 -->
        <b-pagination
          align="center"
          pills
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="itemList"
          class="justify-content-center"
        ></b-pagination>
        <div class="row align-items-center text-center mb-4 small">
          <div class="col-12 col-md mb-2 mb-md-0">
            <go-home-btn
              :btnSize="'sm'"
              :btnClass="'btn-miw mx-1 mb-2'"
              :btnVariant="'primary'"
              :btnName="'回收據雲平台首頁'"
            >
              <template slot="goHomeBtn"></template>
            </go-home-btn>
          </div>
        </div>
      </div>

      <!-- 收據明細 -->
      <detail-modal ref="detailData"></detail-modal>
      <!-- 收據預覽 -->
      <receipt-preview :isHoldReceipBtn="false" ref="receiptPreview"></receipt-preview>
    </layout-fullpage>
  </div>
</template>

<script>
// 引入 json
import { tableTh } from '@/configs/tableTh';

import { mapMutations } from 'vuex';

import LayoutFullpage from '@/layouts/Fullpage.vue';
import Loading from '@/components/Loading.vue';

// 共用 utils
import ApiMixin from '@/mixins/api';
import CommonApiMixin from '@/mixins/commonApi';
import UserMixin from '@/mixins/user';
import MakePdf from '@/mixins/makePdf';

export default {
  name: 'holdReceipt',

  components: {
    LayoutFullpage,
    Loading,
  },

  mixins: [ApiMixin, CommonApiMixin, UserMixin, MakePdf],

  data() {
    return {
      currentPage: 1,
      perPage: 6, // 分頁

      token: '',
      pagination: {
        prePage: 1,
      },

      searchCollapse: false,

      organList: [], // 機關選單
      payItemList: [], // 繳款選單
      payItemListNew: [], // 繳款選單 關聯完
      ispayItemListNew: false, // 繳款選單 開關

      searchForm: {
        rpPublicNo: '',
        oid: '',
        creator: null,
        paymentItem: null,
        createStart: null,
        createEnd: null,
        receiptStart: null,
        receiptEnd: null,
      },

      receiptFile: {
        imagePath: 'mock/receipts/preview.jpg',
        pdfPath: 'mock/receipts/preview.pdf',
      },

      tableData: [],
      tableTh,
      detailData: [],
      due_date: '',
      due_time: '',
      rpPublicNo: null,
      rpPublicRandomCode: null,
      rpId: null,
      rpDownloadCount: null,
      isSearch: false, // 原收據與收據查詢開關
      isDate: true, // 用來看是否是開立日期
      getCode: '',
      // response: {}, // API成功
      error: {}, // API失敗
      startDateVid: null, // 開始 西元年
      endDateVid: null, // 結束 西元年
      getCookieRunVal: '', // 使用者cookid
      cookieUId: '', // 歸戶使用UUID 辨別是否歸戶回來
      sessionId: '', // 放cookie的sessionId
      sessionSource: '',
      hmId: '',
      searchHmId: null, // 查詢收據使用
      cookieName: '',
      UpDataRpPID: '', // 收據號碼
      apiLoading: false,
      ogId: null, // 機關id
      ogInputVal: null, // 機關input Val
      piId: null, // 繳款項目 id
      piInputVal: null,
      resultRpPublicNo: '', // 收據號碼(歸戶用)
    };
  },
  created() {
    this.cookieUId = this.$getUUID('sessionUUId');
    // this.queryUser();
    console.log('islogin', this.$store.state.login.isLogin);
    if (this.$store.state.login.isLogin) {
      // 判斷歸戶
      this.judgmentReturn(this.$store.state.login);
    }
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    tabledatas() {
      return this.tableData.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },

  methods: {
    // 確認使否有登入
    // async queryUser() {
    //   const url = '/GovEReceipt/FrontDeskService/QueryUser';
    //   await this.axiosServiceSend({}, url, 'post', 'QueryUser');
    // },
    // 取歸戶收據 API
    async getData(data) {
      this.apiLoading = true;
      const url = '/GovEReceipt/FrontDeskService/Query';
      await this.axiosServiceSend(data, url, 'post', 'receiptQuery');
    },
    // 取Select資料
    async getSelectItme() {
      const url = '/GovEReceipt/FrontDeskService/QuerySelectBox';
      const method = 'post';
      await this.axiosServiceSend({}, url, method, 'receiptQuerySelectBox');
    },
    // 使用共用API結果
    success(type, res, otherObj) {
      // const { data } = res;
      switch (type) {
        // // 確認使用者
        // case 'QueryUser':
        //   console.log('QueryUser', data);
        //   if (data === '') {
        //     console.log('未登入，走登入');
        //     this.getUserInfo();
        //   } else {
        //     console.log('已登入');
        //     const UserData = JSON.parse(data.object.dataMessage);
        //     const userData = {
        //       userName: UserData.userName,
        //     };
        //     this.changeLogin(userData); // 寫進Vuex裡

        //     // 判斷歸戶
        //     this.judgmentReturn(UserData, data.sessionId, data.sessionSource, UserData.hmId);
        //   }
        //   break;
        // // 登入
        // case 'login':
        //   if (data.ERROR) {
        //     console.log('CODE失效1-2-1');
        //     this.apiLoading = false;
        //     this.$router.push({
        //       name: 'home',
        //     });
        //   } else {
        //     console.log('CODE有效 有資本資料:1-2-2 ', data);
        //     const UserData = JSON.parse(data.dataMessage);

        //     const userData = {
        //       userName: UserData.userName,
        //     };
        //     this.changeLogin(userData); // 寫進Vuex裡
        //     // 判斷歸戶
        //     this.judgmentReturn(UserData, data.sessionId, data.sessionSource, UserData.hmId);
        //   }
        //   break;
        // 取收據資料
        case 'receiptQuery':
          this.tableData = res.data.object;
          this.apiLoading = false;
          break;
        case 'receiptQuerySelectBox': // 下拉選單
          this.organList = res.data.object.organList;
          this.payItemList = res.data.object.payItemList;
          break;
        case 'resultData': // 歸戶資料
          if (this.cookieUId !== '') {
            console.log('1-4-1歸戶資料cookieUId', this.cookieUId);
            this.detailData = JSON.parse(res.data.object.dataMessage);
            console.log('this.detailData:', this.detailData, otherObj);
            if (this.detailData.custRemarkList === null) {
              this.detailData.custRemarkList = [];
            }
            this.detailData.rpHmId = otherObj.hmId;
            this.detailData.sessionId = otherObj.SessionId;
            this.detailData.sessionSource = 'H';
            console.log('處理完this.detailData::', this.detailData);
            this.upData(this.detailData); // 把歸戶資料寫進站存檔(收據資料及rpHmId寫進)
            this.searchHmId = this.detailData;
            this.UpDataRpPID = this.detailData.rpPublicNo; // 歸戶收據號碼
          }
          break;
        case 'resultUpData': // 歸戶 收據 更新完畢
          console.log('detailData攻心岩壁:', this.searchHmId);
          console.log('this.cookieUId', this.cookieUId);
          console.log('1-5-1歸戶成功', res.data.rtnCode);
          if (res.data.rtnCode === '0000') {
            const deleteData = {
              sessionId: this.cookieUId,
              sessionSource: 'H',
            };
            this.$deleteCache(deleteData);
          }
          break;
        case 'deleteCache': // 歸戶 收據 暫存檔砍掉
          if (res.data.object === true) {
            this.$clearCookie('sessionUUId', this.cookieUId);
            console.log('1-7UpDataRpPID:', this.UpDataRpPID);
            this.msgModal(true, this.UpDataRpPID); // 回歸戶成功訊息
            const queryData = {
              sessionId: this.searchHmId.sessionId,
              sessionSource: this.searchHmId.sessionSource,
              rpHmId: this.searchHmId.rpHmId,
            };
            this.getData(queryData);
          }
          break;
        default:
          break;
      }
    },
    fail(type, error, other) {
      console.log('fail-', error, other);
      switch (type) {
        case 'QueryUser':
          console.log('QueryUsererr');
          this.$router.push({
            name: 'home',
          });
          break;
        case 'login':
          console.log('loginerr');
          this.$router.push({
            name: 'home',
          });
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
    /* 使用 code 取 基本資料(連後端)
     */
    // async getUserInfo() {
    //   this.apiLoading = true;
    //   this.getCode = this.$route.query.code;
    //   const data = {
    //     code: this.getCode,
    //   };
    //   const url = '/GovEReceipt/UserLoginService/Login';
    //   await this.axiosServiceSend(data, url, 'post', 'login');
    // },
    /*
      5. 打HomeService/Query Controller
      */
    ...mapMutations('login', ['changeLogin']),

    /*
     非主流程 檢查是有否session cookie
      queryCacheManager(UUID, 類別, 使用者基本資料)  歸戶資料使用
     */
    async queryCacheManager(sessionId, type, UserData) {
      console.log('1-4 | 2-2打API檢查是否有此資料', sessionId);
      // this.apiLoading = true;
      try {
        const data = {
          sessionId,
          sessionSource: 'H',
        };
        const url = '/GovEReceipt/CacheManagerService/Query';
        const method = 'post';
        this.axiosServiceSend(data, url, method, type, UserData);
      } catch (error) {
        this.apiLoading = false;
        console.error(error);
      }
    },
    // 更新 收據資料 (歸戶用)
    async upData(data) {
      console.log('1-5更新 收據資料 (歸戶用):', data);
      // this.apiLoading = true;
      try {
        const url = '/GovEReceipt/FrontDeskService/Update';
        const method = 'post';
        await this.axiosServiceSend(data, url, method, 'resultUpData');
      } catch (error) {
        this.apiLoading = false;
        console.error(error);
      }
    },

    showDetails(rowData, index) {
      this.$refs.detailData.getDetailData(rowData, index);
    },
    // 取 開立西元年
    startDateVidsOpen(value) {
      this.searchForm.receiptStart = value;
      console.log('this.searchForm.receiptStart:', this.searchForm.receiptStart);
    },
    endDateVidsOpen(value) {
      this.searchForm.receiptEnd = value;
      console.log('this.searchForm.receiptEnd: ', this.searchForm.receiptEnd);
    },

    // 基礎查詢
    search() {
      const { rpPublicNo } = this.searchForm;
      this.apiLoading = true;
      const data = {
        rpPublicNo,
        ogId: this.ogId,
        rpDateStart: this.searchForm.receiptStart,
        rpDateEnd: this.searchForm.receiptEnd,
        rpPiId: this.piId,
      };
      this.axiosServiceSend(data, '/GovEReceipt/FrontDeskService/Query', 'post', 'receiptQuery');
    },

    // 取得 機關id
    getInputPkId(id, inputVal) {
      this.ogId = id;
      this.ogIdInputVal = inputVal;
      this.payItemListNew = this.payItemList.filter((item) => {
        return parseInt(item.piOgId, 10) === parseInt(this.ogId, 10);
      });
      this.ispayItemListNew = true;
      if (this.payItemListNew.length === 0) {
        this.ispayItemListNew = false;
        this.piId = null;
      }
      if (this.ogId === null) {
        this.piId = null;
      }
    },

    // 取得 繳款項目id
    getInputPiId(id, inputVal) {
      this.piId = id;
      this.piInputVal = inputVal;
    },

    // 瀏覽
    previewReceipt(rowData) {
      const pdfnym = rowData.pdfNym;
      const data = {
        rpPublicNo: rowData.rpPublicNo,
        rpPublicRandomCode: rowData.rpPublicRandomCode,
      };
      const url = {
        preview: `/GovEReceipt/PdfService/previewPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
        downloadPdf: `/GovEReceipt/PdfService/downloadPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
      };
      this.$refs.receiptPreview.showModal(data, url);
    },
    async msgModal(isSuccess, rpPublicNo) {
      try {
        await this.showApiMessage(
          isSuccess ? 'success' : 'error',
          isSuccess ? `收據號碼：${rpPublicNo} 已完成歸戶！` : '無法歸戶原因....',
          isSuccess ? '歸戶完成' : '執行失敗'
        );
        this.apiLoading = false;
      } catch (error) {
        this.apiLoading = false;
        console.error(error);
      }
    },
    // 判斷是否為 做歸戶 this.cookieUId(是否有值)
    judgmentReturn(UserData, sessionId, sessionSource, rpHmId, chanExpireDate) {
      console.log('judgmentReturn----', UserData, '----', chanExpireDate);
      this.getSelectItme();
      if (this.cookieUId !== '') {
        console.log('1-2-2-1我是歸戶回來:');
        this.queryCacheManager(this.cookieUId, 'resultData', UserData);
      } else {
        console.log('1-2-2-2不是歸為了歸戶，而是只有登入');
        this.getData({}); // 取自己歸戶資料 1-3
      }
    },
    // 取得收據號碼
    inputVal(val) {
      this.searchForm.rpPublicNo = val;
    },
  },
};
</script>
